<ng-container [formGroup]="metadataFormGroup">
  <app-shared-business-form
    [formGroup]="sharedBusinessFormGroup"
    [showStaffFields]="true"
    [showActivityFields]="false"
  />

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations Assurance IJM
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Masse salariale hommes (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="menTotalSalary"
      />
    </div>
    <div class="col">
      <label i18n>Masse salariale femmes (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="womenTotalSalary"
      />
    </div>
  </div>

  <div class="row row-cols-1 my-3">
    <div class="col">
      <label i18n>Pourcentage de couverture (%)</label>
      <input
        type="number"
        min="0"
        max="100"
        class="form-control"
        formControlName="coveragePercent"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Cercle des personnes assurées
  </div>
  <div class="row mb-4">
    <div class="col">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [value]="true"
          id="allCollaboratorsCovered"
          formControlName="allCollaboratorsCovered"
        />
        <label class="form-check-label" for="allCollaboratorsCovered">
          Tous les collaborateurs sont assurés
        </label>
      </div>
    </div>
  </div>
  @if (
    metadataFormGroup?.controls?.['allCollaboratorsCovered']?.value !== true
  ) {
    <div formArrayName="insuredPersons">
      <div
        *ngFor="let personControl of insuredPersons.controls; let i = index"
        [formGroupName]="i"
        class="insured-person-row mb-3 p-3 border rounded"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 i18n>Personne {{ i + 1 }}</h6>
          <button
            type="button"
            class="lty-btn lty-btn-danger btn-sm"
            (click)="removeInsuredPerson(i)"
            i18n
          >
            Supprimer
          </button>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label i18n>Sélectionner un collaborateur (optionnel)</label>
            <select
              class="form-control"
              (change)="onCollaboratorSelected(i, $any($event.target).value)"
            >
              <option [value]="null" i18n>Sélectionner</option>
              <option
                *ngFor="let collaborator of collaborators"
                [value]="collaborator.id"
                [selected]="
                  personControl.value.collaboratorId === collaborator.id
                "
              >
                {{ collaborator.firstName }} {{ collaborator.lastName }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label i18n>Nom complet</label>
            <input
              type="text"
              class="form-control"
              formControlName="fullName"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="lty-btn lty-btn-white add-person-btn me-auto ms-auto w-100"
      (click)="addInsuredPerson()"
    >
      <span class="plus_sign me-2">+</span>
      <span i18n>Ajouter une personne assurée</span>
    </button>
  }

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations du contrat
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option [value]="null" i18n>Sélectionner</option>
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Nombre d'hommes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="menCount"
      />
    </div>
    <div class="col">
      <label i18n>Âge moyen des hommes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="menAverageAge"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Nombre de femmes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="womenCount"
      />
    </div>
    <div class="col">
      <label i18n>Âge moyen des femmes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="womenAverageAge"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Prestations assurées
  </div>

  <ng-container formGroupName="coverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture</label>
        <input type="text" class="form-control" formControlName="coverage" />
      </div>
      <div class="col">
        <label i18n>Taux de salaire assuré</label>
        <select class="form-control" formControlName="insuredSalaryRate">
          <option [value]="null" i18n>Sélectionner</option>
          <option *ngFor="let value of insuredSalaryRateValues" [value]="value">
            {{ getBusinessInsuredSalaryRateLabel(value) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Délai d'attente en jours</label>
        <select class="form-control" formControlName="waitingDelay">
          <option [value]="null" i18n>Sélectionner</option>
          <option *ngFor="let value of waitingDaysValues" [value]="value">
            {{ getBusinessWaitingDaysLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>Durée des prestations en jours</label>
        <select class="form-control" formControlName="coverageDurationDays">
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of coverageDurationDaysValues"
            [value]="value"
          >
            {{ getBusinessCoverageDurationDaysLabel(value) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Système selon</label>
        <select class="form-control" formControlName="coverageSystem">
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of healthCoverageSystemValues"
            [value]="value"
          >
            {{ getBusinessHealthCoverageSystemLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>Couverture dès une incapacité de</label>
        <select
          class="form-control"
          formControlName="invalidityDurationForCoverage"
        >
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of invalidityDurationValues"
            [value]="value"
          >
            {{ getBusinessInvalidityDurationLabel(value) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Salaire dû en cas de décès selon l'art. 338 CO</label>
        <div class="form-check">
          <input
            type="radio"
            id="salaryDueDeathFalse"
            [value]="false"
            formControlName="salaryDueDeath"
          />
          <label class="form-check-label" for="salaryDueDeathFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="salaryDueDeathTrue"
            [value]="true"
            formControlName="salaryDueDeath"
          />
          <label class="form-check-label" for="salaryDueDeathTrue"> Oui </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Complément maternité</label>
        <div class="form-check">
          <input
            type="radio"
            id="maternitySupplementFalse"
            [value]="false"
            formControlName="maternitySupplement"
          />
          <label class="form-check-label" for="maternitySupplementFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="maternitySupplementTrue"
            [value]="true"
            formControlName="maternitySupplement"
          />
          <label class="form-check-label" for="maternitySupplementTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="isNotBasicCoverageSystem()"
    >
      <div class="col">
        <label i18n>Durée des prestations maternité en jours</label>
        <select
          class="form-control"
          formControlName="maternityCoverageDuration"
        >
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of maternityCoverageDurationValues"
            [value]="value"
          >
            {{ getBusinessMaternityCoverageDurationLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>Prestations assurée en maternité</label>
        <mat-form-field class="lty-input">
          <mat-select formControlName="maternityCoverages" multiple>
            <mat-option
              *ngFor="let value of maternityCoverageValues"
              [value]="value"
            >
              {{ getBusinessMaternityCoverageLabel(value) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      class="row row-cols-sm-1 my-3"
      [class.row-cols-md-2]="hasDurationExtension()"
    >
      @if (hasDurationExtension()) {
        <div class="col">
          <label i18n>Prolongation de durée</label>
          <input
            type="number"
            min="0"
            class="form-control"
            formControlName="durationExtension"
          />
        </div>
      }
      <div class="col">
        <label i18n>Délai d'attente en jours</label>
        <select class="form-control" formControlName="coverageWaitingDelay">
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of healthCoverageWaitingDelayValues"
            [value]="value"
          >
            {{ getBusinessHealthCoverageWaitingDelayLabel(value) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Salaire maximum assuré</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="maximumInsuredSalary"
        />
      </div>
      <div class="col">
        <label i18n>Indemnité d'allaitement</label>
        <div class="form-check">
          <input
            type="radio"
            id="breastfeedingAllowanceFalse"
            [value]="false"
            formControlName="breastfeedingAllowance"
          />
          <label class="form-check-label" for="breastfeedingAllowanceFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="breastfeedingAllowanceTrue"
            [value]="true"
            formControlName="breastfeedingAllowance"
          />
          <label class="form-check-label" for="breastfeedingAllowanceTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Durée</label>
        <select
          class="form-control"
          formControlName="breastfeedingAllowanceDuration"
        >
          <option [value]="null" i18n>Sélectionner</option>
          <option
            *ngFor="let value of coverageDurationDaysValues"
            [value]="value"
          >
            {{ getBusinessCoverageDurationDaysLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>Taux hommes</label>
        <input type="text" class="form-control" formControlName="menRate" />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Taux femmes</label>
        <input type="text" class="form-control" formControlName="womenRate" />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Conditions complémentaires
  </div>

  <ng-container formGroupName="supplementaryCoverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture durant les congés non payés</label>
        <div class="form-check">
          <input
            type="radio"
            id="unpaidLeaveCoveredFalse"
            [value]="false"
            formControlName="unpaidLeaveCovered"
          />
          <label class="form-check-label" for="unpaidLeaveCoveredFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="unpaidLeaveCoveredTrue"
            [value]="true"
            formControlName="unpaidLeaveCovered"
          />
          <label class="form-check-label" for="unpaidLeaveCoveredTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Couverture durant le temps d'essai</label>
        <div class="form-check">
          <input
            type="radio"
            id="trialPeriodCoveredFalse"
            [value]="false"
            formControlName="trialPeriodCovered"
          />
          <label class="form-check-label" for="trialPeriodCoveredFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="trialPeriodCoveredTrue"
            [value]="true"
            formControlName="trialPeriodCovered"
          />
          <label class="form-check-label" for="trialPeriodCoveredTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture pour le personnel avec un CDD</label>
        <div class="form-check">
          <input
            type="radio"
            id="cddCoveredFalse"
            [value]="false"
            formControlName="cddCovered"
          />
          <label class="form-check-label" for="cddCoveredFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="cddCoveredTrue"
            [value]="true"
            formControlName="cddCovered"
          />
          <label class="form-check-label" for="cddCoveredTrue"> Oui </label>
        </div>
      </div>
      <div class="col">
        <label i18n
          >Couverture pour les femmes enceintes durant l'engagement</label
        >
        <div class="form-check">
          <input
            type="radio"
            id="pregnancyCoveredFalse"
            [value]="false"
            formControlName="pregnancyCovered"
          />
          <label class="form-check-label" for="pregnancyCoveredFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="pregnancyCoveredTrue"
            [value]="true"
            formControlName="pregnancyCovered"
          />
          <label class="form-check-label" for="pregnancyCoveredTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Participation à l'excédant de primes</label>
        <div class="form-check">
          <input
            type="radio"
            id="excessSalaryCoveredFalse"
            [value]="false"
            formControlName="excessSalaryCovered"
          />
          <label class="form-check-label" for="excessSalaryCoveredFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="excessSalaryCoveredTrue"
            [value]="true"
            formControlName="excessSalaryCovered"
          />
          <label class="form-check-label" for="excessSalaryCoveredTrue">
            Oui
          </label>
        </div>
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('supplementaryCoverages')?.value
            ?.excessSalaryCovered === 'true' ||
          metadataFormGroup.get('supplementaryCoverages')?.value
            ?.excessSalaryCovered === true
        "
      >
        <label i18n>Si oui, période de calcul</label>
        <input
          type="text"
          class="form-control"
          formControlName="premiumSurplusComputingPeriod"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Garantie du taux de prime pendant la durée du contrat</label
        >
        <div class="form-check">
          <input
            type="radio"
            id="fixedPremiumRateFalse"
            [value]="false"
            formControlName="fixedPremiumRate"
          />
          <label class="form-check-label" for="fixedPremiumRateFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="fixedPremiumRateTrue"
            [value]="true"
            formControlName="fixedPremiumRate"
          />
          <label class="form-check-label" for="fixedPremiumRateTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Renonciation à la résiliation sur sinistres</label>
        <div class="form-check">
          <input
            type="radio"
            id="claimTerminationWaiverFalse"
            [value]="false"
            formControlName="claimTerminationWaiver"
          />
          <label class="form-check-label" for="claimTerminationWaiverFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="claimTerminationWaiverTrue"
            [value]="true"
            formControlName="claimTerminationWaiver"
          />
          <label class="form-check-label" for="claimTerminationWaiverTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Garantie de la reprise des cas en cours</label>
        <div class="form-check">
          <input
            type="radio"
            id="guaranteedCaseFollowupFalse"
            [value]="false"
            formControlName="guaranteedCaseFollowup"
          />
          <label class="form-check-label" for="guaranteedCaseFollowupFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="guaranteedCaseFollowupTrue"
            [value]="true"
            formControlName="guaranteedCaseFollowup"
          />
          <label class="form-check-label" for="guaranteedCaseFollowupTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Renouvellement tacite</label>
        <div class="form-check">
          <input
            type="radio"
            id="tacitRenewalFalse"
            [value]="false"
            formControlName="tacitRenewal"
          />
          <label class="form-check-label" for="tacitRenewalFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="tacitRenewalTrue"
            [value]="true"
            formControlName="tacitRenewal"
          />
          <label class="form-check-label" for="tacitRenewalTrue"> Oui </label>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assurance actuelle
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Possède une assurance</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceFalse"
          [value]="false"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceTrue"
          [value]="true"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasInsurance === 'true' ||
        metadataFormGroup.value.hasInsurance === true
      "
    >
      <label i18n>Assureur actuel</label>
      <input
        type="text"
        class="form-control"
        formControlName="currentInsurer"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
